var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips_page"},[_c('div',[_vm._v("呀，页面找不到了! 请确认是否有权访问？")]),_c('el-button',{staticClass:"fanhui",attrs:{"type":"warning"},on:{"click":_vm.clickBack}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }